
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Shell } from "@/components/layout/Shell";
import { ContactForm } from "@/components/contacts/ContactForm";
import { useContacts } from "@/hooks/useContacts";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function ContactEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { useContactQuery } = useContacts();
  const { data: contact, isLoading, isError } = useContactQuery(id || "");

  React.useEffect(() => {
    console.log("ContactEditPage loaded with id:", id);
    console.log("Contact data:", contact);
    console.log("isLoading:", isLoading);
    console.log("isError:", isError);
  }, [id, contact, isLoading, isError]);

  if (isLoading) {
    return (
      <Shell>
        <div className="flex items-center gap-2 mb-6">
          <Button variant="outline" size="icon" onClick={() => navigate("/contacts")}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <Skeleton className="h-8 w-56" />
        </div>
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-1/2" />
        </div>
      </Shell>
    );
  }

  if (isError || !contact) {
    return (
      <Shell>
        <div className="p-6 bg-destructive/10 rounded-md">
          <h1 className="text-xl font-medium text-destructive">Error loading contact</h1>
          <p className="mt-2">
            Could not load the contact you're looking for. It may have been deleted or you may not have permission to view it.
          </p>
          <Button className="mt-4" onClick={() => navigate("/contacts")}>
            Back to Contacts
          </Button>
        </div>
      </Shell>
    );
  }

  return (
    <Shell>
      <div className="flex items-center gap-2 mb-6">
        <Button variant="outline" size="icon" onClick={() => navigate("/contacts")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-3xl font-bold tracking-tight">Edit Contact</h1>
      </div>
      <ContactForm mode="edit" contact={contact} />
    </Shell>
  );
}
